'use client'

// src/constants.ts
var SECTIONS_LIMIT = 9;
var SECTIONS_CONTENT_LIMIT = 27;
var DEFAULT_PAGINATION = 7;

export {
  SECTIONS_LIMIT,
  SECTIONS_CONTENT_LIMIT,
  DEFAULT_PAGINATION
};
//# sourceMappingURL=chunk-UAMS6QZK.mjs.map